import type { Gift, BuyerGift, RecipientGift, PurchasedOrder } from '@consumer/types/serializers'
import type { SupportArticle } from '@consumer/types/SupportArticle'
import { support } from '@consumer/api'

export type { BuyerGift }
export type BuyerOrRecipientGift = Gift & Partial<BuyerGift & RecipientGift>

export function articleUrl (
  article: SupportArticle,
  {
    gift,
    order,
  }: {
    gift?: BuyerOrRecipientGift
    order?: PurchasedOrder
  },
) {
  if (gift) {
    if ('purchaserSupportUrl' in gift) {
      return `${gift.purchaserSupportUrl}/articles/${article.key}`
    }
    if ('recipientSupportUrl' in gift) {
      return `${gift.recipientSupportUrl}/articles/${article.key}`
    }
  }
  else if (order) {
    return `${order.supportUrl}/articles/${article.key}`
  }
  return support.article.path(article)
}
